import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import forbiddenImage from 'assets/images/static/403.svg';
import notFound from 'assets/images/static/404.svg';
import { Row, Col, Card, notification } from 'antd';
import InvoiceInformation from './components/InvoiceInformation';
import PayeInvoices from './components/PayeInvoices';
import CurrentAccountBalance from './components/CurrentAccountBalance';
import PaymentDetails from './components/PaymentDetails';
import announcementService from '../../services/announcement.service';

const Dashboard = (props) => {
  const status = props?.location?.state?.status;

  useEffect(() => {
    const fetchNotificationAnnouncement = async () => {
      try {
        const response = await announcementService.notificationAnnouncement();
        response.payload.map((notificationsTitle) =>
          notification.success({
            message: 'Duyurunuz var!',
            description: (
              <div style={{ fontSize: '16px' }}>
                {notificationsTitle.title}
                <div style={{ textAlign: 'right' }}>
                  {' '}
                  <a href="/duyurular">Detay... </a>{' '}
                </div>{' '}
              </div>
            ),
          }),
        ); // eslint-disable-next-line
      } catch (e) {}
    };
    fetchNotificationAnnouncement();
  }, []);

  if (status === 403) {
    return (
      <div className="dashboard-content">
        <img className="image" src={forbiddenImage} alt="Dashboard" />
        <span>Bu sayfaya yetkiniz bulunmamaktadır.</span>
      </div>
    );
  }
  if (status === 404) {
    return (
      <div className="dashboard-content">
        <img className="image" src={notFound} alt="Dashboard" />
        <span className="message">Sayfa bulunamadı.</span>
      </div>
    );
  }

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col lg={24} xl={12}>
          <Card type="inner">
            <CurrentAccountBalance />
          </Card>
        </Col>
        <Col lg={24} xl={12}>
          <Card type="inner">
            <PaymentDetails />
          </Card>
        </Col>
      </Row>

      <Row gutter={[10, 10]}>
        <Col lg={24} xl={12} className="ant-table-tbody">
          <Card type="inner">
            <InvoiceInformation />
          </Card>
        </Col>

        <Col lg={24} xl={12}>
          <Card type="inner">
            <PayeInvoices />
          </Card>
        </Col>
      </Row>
    </>
  );
};

Dashboard.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      status: PropTypes.number,
    }),
  }).isRequired,
};

export default Dashboard;
